module.exports = __webpack_public_path__ + "static/media/eth-hover.b852a0a1.png";